<template lang="pug">
menu-bar-item(:label=`$t('hscmap')`)
  menu-item(:label=`$t('about_hscmap')`, v-model="Store.modules.about.show")
  menu-separator
  menu-item(:label=`$t('preferences')`, @click="$router.replace('/config')")
  menu-separator
  menu-item(:label=`'English'`, type="radio", v-model="$root.$i18n.locale", value="en")
  menu-item(:label=`'日本語'`, type="radio", v-model="$root.$i18n.locale", value="ja")
  menu-separator
  menu-item(:label="$t('tips')", @click="tips")
</template>


<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component
export default class extends Vue {
  tips() {
    window.open('./help.html')
  }
}
</script>



<i18n>
en:
  hscmap: hscMap
  about_hscmap: About hscMap
  preferences: Preferences...
  tips: Tips
ja:
  hscmap: hscMap
  about_hscmap: hscMapについて
  preferences: 環境設定...
  tips: Tips

</i18n>